// extracted by mini-css-extract-plugin
module.exports = {"header":"FCADc","logo":"uV81K","container":"_2036s","content":"YPL4q","navigation":"kNL2L","card-item":"_6ZrQE"};